// extracted by mini-css-extract-plugin
export var heading = "SectionHeader-module--heading--49a64";